<ng-container *ngIf="this.doctorvideos.length>0">
    <div class="ui-g-12">

        <div class="ui-g">
            <div class="ui-g-12">
                <h1 class="video-h1 text-center"><b>eGlobalDoctors Videos</b></h1>
            </div>

            <div class="ui-g-12" *ngFor="let doctorvideo of doctorvideos">
                <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 text-center">
                        <img [src]="doctorvideo.imgsrc" alt="" class="video-img" />
                    </div>
                    <div class="ui-g-12 ui-md-8">
                        <h3><b> {{doctorvideo.name}} </b></h3>
                        <p>
                            {{doctorvideo.description}}
                        </p>
                        <a [href]="doctorvideo.link" target="_blank">
                            <button pButton type="button" class="video-section-button" label="Watch Videos"></button>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-container>